// openEHR RM model — BMM package org.openehr.rm.ehr_extract.openehr_extract
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

import type { T } from "../_shared.ts";
import type { REVISION_HISTORY } from "../common/generic.ts";
import type { DV_DATE_TIME } from "../data_types/quantity/date_time.ts";
import { EXTRACT_CONTENT_ITEM } from "./common.ts";
import * as openehr_base from "../../base/mod.ts";
import { applyRmInit, type RmInit } from "../../base/apply_rm_init.ts";

/**
 * Form of \`EHR EXTRACT_ITEM\` containing openEHR serialised \`VERSIONED_OBJECTs\`.
 */
export class OPENEHR_CONTENT_ITEM extends EXTRACT_CONTENT_ITEM {
  constructor(init?: RmInit) { super(); applyRmInit(this, init); }

  /**
   * Content object.
   */
  override item?: openehr_base.Any = undefined;
}

/**
 * Variety of Extract content that consists is a sharable data-oriented version of \`VERSIONED_OBJECT<T>\`.
 */
export class X_VERSIONED_OBJECT<T> {
  constructor(init?: RmInit) { applyRmInit(this, init); }

  /**
   * Uid of original \`VERSIONED_OBJECT\`.
   */
  uid?: openehr_base.HIER_OBJECT_ID;
  /**
   * Owner_id from original \`VERSIONED_OBJECT\`, which identifies source EHR.
   */
  owner_id?: openehr_base.OBJECT_REF;
  /**
   * Creation time of original \`VERSIONED_OBJECT\`.
   */
  time_created?: DV_DATE_TIME;
  /**
   * Internal storage for total_version_count
   * @protected
   */
  protected _total_version_count?: openehr_base.Integer;

  /**
   * Total number of versions in original \`VERSIONED_OBJECT\` at time of creation of this \`X_VERSIONED_OBJECT\`.
   */
  get total_version_count(): number | undefined {
    return this._total_version_count?.value;
  }

  /**
   * Gets the openehr_base.Integer wrapper object for total_version_count.
   * Use this to access openehr_base.Integer methods.
   */
  get $total_version_count(): openehr_base.Integer | undefined {
    return this._total_version_count;
  }

  /**
   * Sets total_version_count from either a primitive value or openehr_base.Integer wrapper.
   */
  set total_version_count(val: number | openehr_base.Integer | undefined) {
    if (val === undefined || val === null) {
      this._total_version_count = undefined;
    } else if (typeof val === "number") {
      this._total_version_count = openehr_base.Integer.from(val);
    } else {
      this._total_version_count = val;
    }
  }

  /**
   * Internal storage for extract_version_count
   * @protected
   */
  protected _extract_version_count?: openehr_base.Integer;

  /**
   * The number of Versions in this extract for this Versioned object, i.e. the count of items in the versions attribute. May be 0 if only revision history is requested.
   */
  get extract_version_count(): number | undefined {
    return this._extract_version_count?.value;
  }

  /**
   * Gets the openehr_base.Integer wrapper object for extract_version_count.
   * Use this to access openehr_base.Integer methods.
   */
  get $extract_version_count(): openehr_base.Integer | undefined {
    return this._extract_version_count;
  }

  /**
   * Sets extract_version_count from either a primitive value or openehr_base.Integer wrapper.
   */
  set extract_version_count(val: number | openehr_base.Integer | undefined) {
    if (val === undefined || val === null) {
      this._extract_version_count = undefined;
    } else if (typeof val === "number") {
      this._extract_version_count = openehr_base.Integer.from(val);
    } else {
      this._extract_version_count = val;
    }
  }

  /**
   * Optional revision history of the original \`VERSIONED_OBJECT\`. If included, it is the complete revision history.
   */
  revision_history?: REVISION_HISTORY;
  /**
   * 0 or more Versions from the original \`VERSIONED_OBJECT\`, according to the Extract specification.
   */
  versions?: undefined;
}

/**
 * Form of \`X_VERSIONED_OBJECT\` for \`EHR_ACCESS\` EHR object.
 */
export class X_VERSIONED_EHR_ACCESS extends X_VERSIONED_OBJECT<T> {
  constructor(init?: RmInit) { super(); applyRmInit(this, init); }

}

/**
 * Form of \`X_VERSIONED_OBJECT\` for \`EHR_STATUS\` EHR object.
 */
export class X_VERSIONED_EHR_STATUS extends X_VERSIONED_OBJECT<T> {
  constructor(init?: RmInit) { super(); applyRmInit(this, init); }

}

/**
 * Form of \`X_VERSIONED_OBJECT\` for \`COMPOSITION\` EHR object.
 */
export class X_VERSIONED_COMPOSITION extends X_VERSIONED_OBJECT<T> {
  constructor(init?: RmInit) { super(); applyRmInit(this, init); }

}

/**
 * Form of \`X_VERSIONED_OBJECT\` for \`FOLDER\` EHR object.
 */
export class X_VERSIONED_FOLDER extends X_VERSIONED_OBJECT<T> {
  constructor(init?: RmInit) { super(); applyRmInit(this, init); }

}

/**
 * Form of \`X_VERSIONED_OBJECT\` for \`PARTY\` demographic object.
 */
export class X_VERSIONED_PARTY extends X_VERSIONED_OBJECT<T> {
  constructor(init?: RmInit) { super(); applyRmInit(this, init); }

}
